// Converts ISO 8601 datetime string to "HH:MM"
export const toHHMM = iso => (typeof iso === 'string' && iso.length >= 16 ? iso.slice(11, 16) : '');

// Converts "HH:MM" to pixel offset and height for program display
export const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

// Rounds down or up to nearest half hour
export const floorToHalfHour = minutes => Math.floor(minutes / 30) * 30;
export const ceilToHalfHour = minutes => Math.ceil(minutes / 30) * 30;

// Converts minutes since midnight to "HH:MM" and vice versa
export const minutesToHHMM = minutes => {
    const m = ((minutes % (24 * 60)) + 24 * 60) % (24 * 60);
    const hh = String(Math.floor(m / 60)).padStart(2, '0');
    const mm = String(m % 60).padStart(2, '0');
    return `${hh}:${mm}`;
};

// Converts "HH:MM" to minutes since midnight, handling invalid input gracefully
export const hhmmToMinutes = hhmm => {
    if (typeof hhmm !== 'string') return null;
    const [h, m] = hhmm.split(':').map(Number);
    if (Number.isNaN(h) || Number.isNaN(m)) return null;
    return h * 60 + m;
};
